import { useResizeObserver } from "@tellescope/react-hooks";

export const useContainerWidth = <T extends HTMLElement = HTMLDivElement>() => {
  const { ref, value: width } = useResizeObserver<number, T>(
    (element, entry) => entry?.contentRect.width ?? element.getBoundingClientRect().width,
    0
  );

  return { ref, width };
};
